module.exports = __webpack_public_path__ + "static/media/face-vomiting-svgrepo-com.9f588c56.svg";